import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function getAthleteProfileUrl(slug: string) {
  const baseUrl = import.meta.env.VITE_ATHLETE_FLOW_BASE_URL || 'https://app.athios.ai'
  // Remove trailing slashes from baseUrl if present
  const cleanBaseUrl = baseUrl.replace(/\/$/, '')
  return `${cleanBaseUrl}/p/${slug}`
}

export function getUniversalProfileUrl(athleteHashedId: string) {
  const baseUrl = import.meta.env.VITE_MANAGER_FLOW_URL || 'http://localhost:8083'
  return `${baseUrl.replace(/\/$/, '')}/p/athletes/${athleteHashedId}`
}
